<template>
  <div class="also-read-wrapper">
    <div :class="`also-read-article-wrapper ${article.isLast ? 'last': ''}`">
      <span class="also-read-tag">also read</span>
      <div class="also-read-content" gtm-event-category="Scroll Article">
        <article-level-three v-if="article.layoutType === 3" :node="article.node"></article-level-three>
        <article-level-four v-else :node="article.node"></article-level-four>
      </div>
    </div>
  </div>
</template>
<script>
  import ArticleLevelThree from 'components/article-levels/Lv3.vue'
  import ArticleLevelFour from 'components/article-levels/Lv4.vue'

  export default {
    name: 'also-read',
    props: {
      article: {
        type: Object,
        default: () => ({}),
      },
    },
    components: {
      ArticleLevelThree,
      ArticleLevelFour,
    },
  }
</script>
<style lang="scss" scoped>
  .also-read-wrapper {
    margin-top: rem-calc(28);
    @include respond-to('desktop') {
      margin-top: rem-calc(40);
    }
  }

  .also-read-article-wrapper,
  .also-read-wrapper {
    margin-bottom: rem-calc(28);
    @include respond-to('desktop') {
      margin-bottom: rem-calc(40);
    }
  }

  .also-read-tag {
    color: $black;
    position: relative;
    background-color: $waterspout2;
    text-transform: uppercase;
    font-weight: bold;
    display: inline-block;
    font-size: rem-calc(14);
    line-height: rem-calc(26);
    padding: rem-calc(2 12 0 16);
    font-family: $barlow;

    &:before {
      width: 0;
      height: 0;
      border-style: solid;
      border-width: rem-calc(12 0 0 12);

      border-color: transparent transparent transparent $white;
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }

  .also-read-content {
    border-style: solid;
    border-color: $waterspout2;
    border-width: rem-calc(4 0);
  }
</style>



// WEBPACK FOOTER //
// AlsoRead.vue?05bd3d6e